var map = {
	"./PromptPay2.png": "8fa1",
	"./Thai_QR_Payment_Logo-03.png": "2d9c",
	"./app-store.png": "aadb",
	"./gbp_credit_card.png": "4098",
	"./gbp_mobile_banking.png": "c71f",
	"./gbp_qr_code.png": "04bf",
	"./google-play-badge.png": "2d68",
	"./kbank_qr_code.png": "7389",
	"./linepay-logo.png": "48f7",
	"./logo.png": "a1d8",
	"./logo_stockradars.png": "9e6c",
	"./truemoneywallet-logo.png": "b640"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3c";